import React, {useState} from 'react';

import TextInput from '../Form/TextInput/TextInput';
import withFeatureFlags from '../FeatureFlags/withFeatureFlags';
import Modal from "../Modal/Modal";
import Button from "../Form/Button/Button";

/** @import {FullNameProps} from './FullNameTypes' */
/** @import {WithFeatureFlagsProps} from '../FeatureFlags/FeatureFlagsTypes' */

import "./nameChangeModal.scss";

function FullName(/** @type {FullNameProps & WithFeatureFlagsProps} */ { profile, featureEnabled }) {
    const [showNameChangePopup, setShowNameChangePopup] = useState(false);

    const handleShow = () => {
        setShowNameChangePopup(true);
    };
    
    const handleClose = () => {
        setShowNameChangePopup(false);
    }

    const nameChangeModal = () => {
        return (
            <Modal className="name-modal name-change__fixed-height" hideClose={true}>
                <h4 className="name-modal__title">How can I change my name?</h4>
                <p className="name-modal__content">You can change your name by emailing us from the email address linked to your Investec Save account.</p>
                <p className="name-modal__content">If you made a mistake when you applied, let us know the correct spelling in the email. You won’t need to send any documents.</p>
                <p className="name-modal__content">If your name has changed, we’ll need a full colour photo of one of the following certified documents, depending on which one is relevant:
                    <ul className='checklist'>
                        <li className='checklist__item'>A decree absolute or dissolution order</li>
                        <li className='checklist__item'>A deed poll</li>
                        <li>A marriage or civil partnership certificate</li>
                    </ul>
                </p>
                <p className="name-modal__content">Our email address is: <a href="mailto:InvestecSavingsServicing@investec.co.uk" target="_blank" rel="noreferrer">InvestecSavingsServicing@investec.co.uk</a></p>
                <div className="name-modal__spacer" />
                <Button size='med' customClassNames={["modal__button", "modal__button--left"]} label="Got it" onClick={handleClose} />
            </Modal>
        )
    };

    return (
    <div className="my-profile__section my-profile__section--margin-bottom">
      <h2 className="my-profile__section-title my-profile__section-title--align-baseline">
      Full name
      </h2>
      {featureEnabled('CustomerNameUpdate') && (
          <div className="my-profile__link">
          <a href={"javascript:void()"} onClick={handleShow}>How do I change my name?</a>
      </div>)}
      <div className="my-profile__row">
        <div className="my-profile__col my-profile__col--margin-bottom">
          <TextInput value={profile.name} label='First name' disabled />
        </div>
        <div className="my-profile__col my-profile__col--margin-bottom">
          <TextInput value={profile.middleName} label='Middle name' disabled />
        </div>
        <div className="my-profile__col my-profile__col--margin-bottom">
          <TextInput value={profile.surname} label='Surname' disabled />
        </div>
      </div>
      {showNameChangePopup && nameChangeModal()}
    </div>
  );
};

export default withFeatureFlags(FullName);
